<template>
  <ErrorGenericView
      :title="currentError.title"
      :description="description"
      :button-text="'Go Premium' | trans"
      :back-button-text="'No thanks' | trans"
      :can-dismiss="false"
      :is-state-loading="isStateLoading"
      @generic-action.stop.prevent="$emit('generic-action', $event)"
      @sign-up.stop.prevent="$emit('sign-up', $event)"
      @refer-a-friend.stop.prevent="$emit('refer-a-friend', $event)"
      :show-try-premium-button="showTryPremiumButton"
      :show-sign-up-button="showSignUpButton"
      :show-referral-button="showReferralButton"
  >
  </ErrorGenericView>
</template>

<script>
import ErrorGenericView from './ErrorGenericView';
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import {testIsEmptyArray} from '../../../../../lib/test-and-assert/test-base';
import {SelfAdjustingTimer} from '../../../../../lib/timer/self-adjusting-timer';

function parseSecondsToReadable(seconds) {
  let s = seconds % 60;
  let m = Math.floor(seconds / 60) % 60;
  let h = Math.floor(seconds / 60 / 60);

  if (s <= 9) {
    s = '0' + s;
  }

  if (m <= 9) {
    m = '0' + m;
  }

  if (h <= 9) {
    h = '0' + h;
  }

  return `${h}:${m}:${s}`;
}

function parseSecondsToReadableDate(seconds) {
  let d = Math.floor(seconds / (3600*24));

  return `${d} ` + Translator.trans('days');
}

/**
 * @type {?SelfAdjustingTimer}
 */
let timer = null;

export default {
  name: 'ErrorCountdownView',
  components: {ErrorGenericView},
  mixins: [TransFilter],
  props: {
    isStateLoading: {
      type: Boolean,
      default: false,
    },
    currentError: {
      type: Object,
      required: true,
    },
    showTryPremiumButton: {
      type: Boolean,
      default: true,
    },
    showSignUpButton: {
      type: Boolean,
      default: false,
    },
    showReferralButton: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.currentError.data.currentTtl <= 0) {
      this.$parent.dismiss();

      return;
    }

    this.timerCount = this.currentError.data.currentTtl;

    timer = new SelfAdjustingTimer(1, this.timerCountDown);
  },
  computed: {
    description() {
      if (testIsEmptyArray(this.currentError.description)) {
      return [];
      }

      let displayText = this.currentError.description.map(element => {
        if (element.includes('%time%')) {
          return element.replace('%time%', `<strong>${this.readableCounter}</strong>`);
        }
        return element;
      });

      return displayText;
    },
    readableCounter() {
      if (this.timerCount > 60 * 60 * 24 * 2) {
        return parseSecondsToReadableDate(this.timerCount);
      }
      return parseSecondsToReadable(this.timerCount);
    },
  },
  methods: {
    timerCountDown() {
      if (this.timerCount <= 0) {
        timer.stop();

        this.$parent.dismiss();

        return;
      }

      this.timerCount--;
    },
  },
  data() {
    return {
      timerCount: 0,
    };
  },
};
</script>
